<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Chat from "@/models/chat.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Chat.getSchema(),
			};
		},
		methods: {
			openEntity(chat) {
				this.$router.push(`/chat/${chat.userId}`);
			},
			searchEntities(paginationParameters) {
				if (paginationParameters.orderBy === "lastMessage") paginationParameters.orderDirection = "desc";
			
				return Chat.search(paginationParameters);
			},
		},
	}
</script>
